import { memo, useState } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router';

import Main from './pages/Main';
import PlayerDetail from './pages/PlayerDetail';
import { TopScorerProvider } from './store';
import { DataHandler } from './utils/DataHandler';

const App = ({ options }) => {
  DataHandler.getInstance(options);

  const [fromMain, setFromMain] = useState(false);

  return (
    <TopScorerProvider>
      <Router>
        <Routes>
          <Route path='/' element={<Main options={options} fromMain={fromMain} setFromMain={setFromMain} />} />
          <Route path='player/:playerId' element={<PlayerDetail options={options} fromMain={fromMain} />} />
        </Routes>
      </Router>
    </TopScorerProvider>
  );
};

export default memo(App);
